module.exports = __webpack_public_path__ + "static/media/layers.dd4e06ce.svg";